import send from '../../util/request';


// 密码找回 手机号验证码
export function resetMobileCodeApi(params = {}) {
  return send({ url: '/ipp/v3/public/reset-mobile-code', method: 'POST', data: params });
}
// 密码找回 邮箱验证码
export function resetMailCodeApi(params = {}) {
  return send({ url: '/ipp/v3/public/reset-email-code', method: 'POST', data: params });
}

// 密码找回 手机号 提交
export function resetMobileApi(params = {}) {
  return send({ url: '/ipp/v3/public/reset-password-for-mobile', method: 'POST', data: params });
}

// 密码找回 邮箱验证码 提交
export function resetMailApi(params = {}) {
  return send({ url: '/ipp/v3/public/reset-password-for-email', method: 'POST', data: params });
}